import { useMemo } from 'react'

export type PlatformMode = 'meridian' | 'cloudscape'

/**
 * Reads the `platform` query parameter from the browser's top-level query string
 * (window.location.search), NOT from the hash-based router params.
 *
 * This is intentional because the app uses HashRouter, and the `platform` param
 * is set by the hosting environment (Mons, native shell) in the main URL query
 * string — alongside `domain`, `region`, and `storeId`.
 *
 * Only exact case-sensitive "meridian" returns 'meridian'; everything else
 * (absent, "cloudscape", any other value) returns 'cloudscape'.
 *
 * Default is 'cloudscape' (Portal mode). Handheld sessions that need App Mode
 * must pass `?platform=meridian` explicitly.
 */
export const usePlatformMode = (): PlatformMode => {
    return useMemo(() => {
        const params = new URLSearchParams(window.location.search)
        const platform = params.get('platform')
        return platform === 'meridian' ? 'meridian' : 'cloudscape'
    }, [])
}
